import React from "react"
import { useSelector } from "react-redux"

import { ACTIVE, INACTIVE } from "const"
import { StoreType, AccountFilters } from "client/store"
import { ActiveInactive } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchAccount {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    showExpiredFilters?: boolean
    filters: AccountFilters
    onFilter: (filters: AccountFilters) => void
}

const statusArray = [ACTIVE, INACTIVE]

const AccountSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    showExpiredFilters = false,
    filters,
    onFilter,
}: SearchAccount) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = []

    statusArray.forEach((status: ActiveInactive) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: AccountFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: AccountFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    if (showExpiredFilters) {
        popupFilters.push(
            {
                title: lang.expired,
                isActive: filters.packageExpired,
                onAdd: (obj: AccountFilters) => ({
                    ...obj,
                    packageExpired: true,
                    packageAlmostExpired: false,
                }),
                onClose: (obj: AccountFilters) => ({
                    ...obj,
                    packageExpired: false,
                }),
            },
            {
                title: lang.almostExpired,
                isActive: filters.packageAlmostExpired,
                onAdd: (obj: AccountFilters) => ({
                    ...obj,
                    packageExpired: false,
                    packageAlmostExpired: true,
                }),
                onClose: (obj: AccountFilters) => ({
                    ...obj,
                    packageAlmostExpired: false,
                }),
            },
        )
    }

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default AccountSearch
